var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbOperatingNotices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-139.001 -1387) translate(139.001 1387)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.067 10.824l-1.155-1.155a.577.577 0 0 0-.816 0L52.169 16.6A.577.577 0 0 0 52 17v1.155a.577.577 0 0 0 .577.577h1.154a.577.577 0 0 0 .408-.169l6.927-6.927a.577.577 0 0 0 .001-.812z",
    transform: "translate(-139.001 -1387) translate(-1402.392 831.032) translate(1502.545 547.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 25.074a1.732 1.732 0 0 1-1.225.507h-1.73a1.155 1.155 0 0 1-1.155-1.155V22.7a1.731 1.731 0 0 1 .507-1.224l3.97-3.976h-14.29a.577.577 0 0 0-.577.577v18.468a.577.577 0 0 0 .577.577h17.318a.577.577 0 0 0 .577-.577V21.101zm-10.46-4.111h2.31a.577.577 0 0 1 0 1.155h-2.309a.577.577 0 0 1 0-1.155zm0 3.464h2.31a.577.577 0 0 1 0 1.155h-2.309a.577.577 0 0 1 0-1.155zm10.391 8.082h-10.39a.577.577 0 0 1 0-1.155h10.39a.577.577 0 0 1 0 1.155zm0-3.464h-10.39a.577.577 0 0 1 0-1.155h10.39a.577.577 0 0 1 0 1.155z",
    transform: "translate(-139.001 -1387) translate(-1402.392 831.032) translate(1531 541.809)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbOperatingNotices);
export default __webpack_public_path__ + "static/media/rb-operating-notices.c8ec8c467a1191957ffcf34ddee70745.svg";
export { ForwardRef as ReactComponent };